// @material-ui/core
import { TextField } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from "react-router";
import { compose } from "redux";
import { pageStyles, withPage } from "../../library/pages";

class Customers extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired
  };

  state = {
    newCustomer: {
      id: "",
      numberOfUsers: 0,
      name: "",
      primaryDomain: "",
      domainList: [],
      superAdmin: ""
    }
  };

  handleChange = name => event => {
    this.setState(
      {
        newCustomer: { ...this.state.newCustomer, [name]: event.target.value }
      },
      () => {
        this.props.handleChange(this.state.newCustomer);
      }
    );
  };

  render() {
    return (
      <React.Fragment>
        <TextField
          id="name"
          label="Company"
          value={this.state.newCustomer.name}
          margin="normal"
          fullWidth={true}
          onChange={this.handleChange("name")}
        />

        <TextField
          id="id"
          label="Customer G Suite ID"
          type="id"
          value={this.state.newCustomer.id}
          margin="normal"
          fullWidth={true}
          onChange={this.handleChange("id")}
        />
      </React.Fragment>
    );
  }
}

export default compose(withRouter, withPage, withStyles(pageStyles))(Customers);



// WEBPACK FOOTER //
// ./src/pages/customers/Customers.js